export const FlareXMLDeclaration = '<?xml version="1.0" encoding="utf-8"?>';
